import { Typography } from '@/components/common';
import { InputRangeDate } from '@/components/form';
import { errorFieldMessage } from '@/const';
import * as React from 'react';
import {
	FieldErrors,
	FieldValues,
	UseFormGetValues,
	UseFormRegister,
	UseFormSetValue,
} from 'react-hook-form';

interface DateQuestionI {
	index: number;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	errors: FieldErrors<FieldValues>;
	getValues: UseFormGetValues<FieldValues>;
}

export const DateQuestion: React.FC<DateQuestionI> = ({
	index,
	register,
	setValue,
	errors,
	getValues,
}) => {
	const getFormattedDate = (date: string) => {
		if (!date) return '';
		const arrayDate = date.split('-');
		if (arrayDate.length < 3) return '';
		// If it's already in YYYY-MM-DD format (first element length is 4)
		if (arrayDate[0].trim().length === 4) {
			return `${arrayDate[0].trim()}-${arrayDate[1].trim()}-${arrayDate[2].trim()}`;
		}
		return `${arrayDate[2].trim()}-${arrayDate[0].trim()}-${arrayDate[1].trim()}`;
	};
	const rules = {
		expected_answer: {
			required: { value: true, message: errorFieldMessage },
		},
	};
	const dateValue = getValues(`questions[${index}].expected_answer`);
	const splitDate = dateValue ? dateValue?.split('-') : undefined;
	const dateFrom = splitDate?.length
		? getFormattedDate(splitDate[0].replaceAll('/', '-'))
		: undefined;
	const dateTo = splitDate?.length
		? getFormattedDate(splitDate[1].replaceAll('/', '-'))
		: undefined;

	return (
		<div className="space-y-4">
			<Typography type="regular-16">Select the correct answer</Typography>
			<InputRangeDate
				title="Date"
				restrictToPast
				name={`questions[${index}].expected_answer`}
				id={`questions[${index}].expected_answer`}
				register={register}
				setValueInput={setValue}
				className="w-[404px]"
				classNameInput="!placeholder-[#0D061633]"
				rules={rules.expected_answer}
				error={(errors?.questions as any)?.[index]?.expected_answer}
				dateFrom={dateFrom}
				dateTo={dateTo}
			/>
		</div>
	);
};
